import React from 'react';
import { Paper } from '@mui/material';

interface SurfaceCardProps {
  children: React.ReactNode;
  sx?: object;
}

const SurfaceCard: React.FC<SurfaceCardProps> = ({ children, sx }) => {
  return (
    <Paper
      sx={{
        borderRadius: 3,
        background: 'var(--surface, #131F33)',
        border: '1px solid var(--border, rgba(140, 166, 209, 0.16))',
        boxShadow: 'var(--shadow-card, 0 10px 30px rgba(2, 8, 20, 0.45))',
        ...sx,
      }}
    >
      {children}
    </Paper>
  );
};

export default SurfaceCard;
